import axios from 'axios';
import * as types from './Favorites.types';
import { showNotification } from './../../utils';
import * as loginSelectors from './../Login/Login.selectors';
import * as loginActions from './../Login/Login.actions';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchFavorites = () => (dispatch, getState) => {
    const cxmlData = loginSelectors.getCxmlData(getState());

    let params = [];
    params.push('cxml_id='  + cxmlData.id);
    params.push('cxml_buyer_cookie='  + cxmlData.buyer_cookie);
    params.push('cxml_browser_form_post='  + cxmlData.browser_form_post);
    params.push('cxml_supplier_domain='  + cxmlData.supplier_domain);
    params.push('cxml_supplier_id='  + cxmlData.supplier_id);
    params.push('cxml_buyer_domain='  + cxmlData.buyer_domain);
    params.push('cxml_buyer_id='  + cxmlData.buyer_id);

    dispatch({ type: types.FETCH_FAVORITES, payload: null });
    axios.get(apiUrl + '/uthealth-favorites?' + params.join('&'),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_FAVORITES_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_FAVORITES_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const deleteFavorite = (id) => (dispatch, getState) => {
    dispatch({ type: types.DELETE_FAVORITE, payload: null });
    axios.delete(apiUrl + '/uthealth-favorites/' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DELETE_FAVORITE_SUCCESS, payload: response.data });
            dispatch(fetchFavorites());
        })
        .catch((error) => {
            dispatch({ type: types.DELETE_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}